import axios from '@/utils/axios'
import Axios from 'axios'
import { downloadFile } from '@/utils'

export const APP_CODE = 'activity-platform'
export const SUB_APP_CODE = 'activity-pc-manage-api-new'

// 上传
function upload (url, fileData, params = {}, otherData = {}) {
  const formData = new FormData()

  if (Array.isArray(fileData)) {
    fileData.forEach((item) => formData.append('files', item, item.name))
  } else {
    formData.set('file', fileData, fileData.name)
  }

  for (const [key, value] of Object.entries(otherData)) {
    if (key) {
      formData.append(key, value)
    }
  }
  return axios.post(url, formData, {
    params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 按照模块，export对象，避免命名冲突；也可直接export方法，优先选择export对象
// 定义方法时，描述参数结构，传递参数后进行结构，而不要直接传递data或者params对象
// 示例：
export const demo = {
  uploadFile (file) {
    return upload('/xxxx', file)
  },
  downloadFile (fileId) {
    return axios.get(`/design-file-share/file/download/${fileId}`, {
      responseType: 'blob'
    })
      .then((response) => {
        downloadFile(response)
      })
  }
}

export const common = {
  downloadTemplate(reportName) {
    return axios.get(`/qu-platform-excel-api/excel/cfg/getTemplate/${reportName}`)
  },
  login ({ phone, password }) {
    return axios.post('/activity-pc-manage-api/pc/login', {
      phone,
      password
    })
  },
  importFile (file, taskDTO) {
    return upload('/qu-platform-excel-api/excel/import/task', file, {}, {
      taskDTO: JSON.stringify(taskDTO)
    })
  },
  importStatus(taskId) {
    return axios.get(`/qu-platform-excel-api/excel/task/status/${taskId}`)
  },
  getMenus () {
    return axios.post('/qu-platform-auth-api/auth/acl/tree/user', {}, {
      params: {
        appCode: APP_CODE,
        subAppCode: SUB_APP_CODE
      }
    })
  },
  checkPermission (telephone) {
    return axios.post('/qu-platform-auth-api/user/release/auth', {
      telephone,
      appCode: SUB_APP_CODE
    })
  },
  doExport (reportName, paramMap) {
    return axios.post('/qu-platform-excel-api/excel/export/task', {
      appCode: SUB_APP_CODE,
      reportName,
      paramMap
    })
  },
  getButtonPermissionsCombined() {
    const request1 = this.getPlatformButtonPermission();
    const request2 = this.getButtonPermission();

    return Promise.all([request1, request2]).then(([response1, response2]) => {
      const data1 = response1.data || [];
      const data2 = response2.data || [];
      return [...data1, ...data2];
    });
  },
  
  // 获取办公按钮的权限列表 角色管理使用
  getPlatformButtonPermission () {
    return axios.post('/qu-platform-auth-api/auth/acl/list/user/button', {}, {
      params: {
        subAppCode: 'qu-platform-auth-api'
      }
    })
  },
  // 拓客宝按钮权限列表
  getButtonPermission() {
    return axios.post('/qu-platform-auth-api/auth/acl/list/user/button', {}, {
      params: {
        subAppCode: SUB_APP_CODE
      }
    });
  },
  getUserInfo () {
    return axios.get('/qu-platform-auth-api/user/home/user/info')
  },
  // 我的应用
  getMyApps () {
    return axios.get('/qu-platform-auth-api/myApp/list')
  },
  customColumnExport (data) {
    return axios.post('/qu-platform-excel-api/excel/customColumn/export/task',data)
  },
  uploadImg (fileData, otherData) {
    otherData = {
      appCode: SUB_APP_CODE,
      compressFlag: 'Y',
      scale: 80,
      ...otherData
    }
    return upload('/qu-file-upload-api/upload/app/uploadImg',
      Array.isArray(fileData) ? fileData : [fileData],
      {},
      otherData
    )
  },
  uploadVideo(fileData) {
    return upload('/qu-file-upload-api/upload/app/uploadVideo', 
      fileData, 
      {}, 
      {
        appCode: SUB_APP_CODE,
      });
  },
  uploadFile(fileData) {
    return upload('/qu-file-upload-api/upload/app/uploadFile', 
      fileData, 
      {}, 
      {
        appCode: SUB_APP_CODE,
      });
  },
  
  // 列表上移下移
  removeSeq(data) {
    return axios.post('/activity-pc-manage-api/activity/tmp/removeSeq',data)
  }
}

// 模板管理
export const templateMgmt = {
  getComponentList (data) {
    return axios.post('/activity-pc-manage-api/module/getActivityModules', data)
  },
  getTemplateList (data) {
    return axios.post('/activity-pc-manage-api/activity/tmp/queryActivityTmps', data)
  },
  getTemplateInfoById (tmpId) {
    return axios.get(`/activity-pc-manage-api/activity/tmp/getTmpById/${tmpId}`)
  },
  saveTemplate (data) {
    return axios.post('/activity-pc-manage-api/activity/tmp/saveActivityTmp', data)
  },
  updateTemplateState (tmpId, tmpStatus) {
    return axios.get(`/activity-pc-manage-api/activity/tmp/updateActivityTmpStatus/${tmpId}/${tmpStatus}`)
  },
  queryUserRole () {
    return axios.post(`/activity-pc-manage-api/activity/tmp/queryUserRole`)
  },
}

// 轮播
export const carouselImage = {
  getList (data) {
    return axios.post('/activity-pc-manage-api/rollingConfig/queryRollings', data)
  },
  save (data) {
    return axios.post('/activity-pc-manage-api/rollingConfig/saveOrUpdate', data)
  },
  updateState (rollingId, rollingStatus) {
    return axios.get(`/activity-pc-manage-api/rollingConfig/rollingOperate/${rollingId}/${rollingStatus}`)
  }
}

// 活动管理
export const ActivityManagement = {
  activityList (data) {
    return axios.post('/activity-pc-manage-api/activity/queryActivityPageList', data)
  },
  preview (data) {
    return axios.get(`/activity-pc-manage-api/activity/previewActivity/${data}`)
  },
  activityDetail (data) {
    return axios.get(`/activity-pc-manage-api/activity/activityInfo/${data}`)
  },
  closeActivity (data) {
    return axios.get(`/activity-pc-manage-api/activity/closeActivity/${data}`)
  },
  activityStoreInfo (data) {
    return axios.post('/activity-pc-manage-api/activity/activityStoreInfo', data)
  },
  activityLotteryRecord (data) {
    return axios.post('/activity-pc-manage-api/activity/getActivityLotteryRecord', data)
  },
  activityAwards (data) {
    return axios.post('/activity-pc-manage-api/activity/getActivityAwards', data)
  },

  activitySignUpInfo (data) {
    return axios.post('/activity-pc-manage-api/activity/activitySignUpInfo', data)
  },
  //活动报名统计数据
  activitySignUpStatsInfo (data) {
    return axios.post('/activity-pc-manage-api/activity/activitySignUpStatsInfo', data)
  },
  activityPreview(data) {
    return axios.post(`/activity-pc-manage-api/activity/poster`,data)
  },
  getActivitySeckillOrder(data) {
    return axios.post(`/activity-pc-manage-api/activity/getActivitySeckillOrder`,data)
  },
  getActivityGoods(data) {
    return axios.post(`/activity-pc-manage-api/activity/getActivityGoods`,data)
  },
  getActivitySessions(data) {
    return axios.post(`/activity-pc-manage-api/activity/getActivitySessions`,data)
  },
  activityPreview (data) {
    return axios.post('/activity-pc-manage-api/activity/poster', data)
  },
  // 活动门店参与职员数据
  activityJoinStaffInfo(data) {
    return axios.post(`/activity-pc-manage-api/activity/activityJoinStaffInfo`,data)
  },
  // 活动数量查询
  findActivityNum(data) {
    return axios.get(`/activity-pc-manage-api/activity/findActivityNum`,data)
  },
  // 问答挑战记录
  getActivityQuestionAnswerLog(data) {
    return axios.post(`/activity-pc-manage-api/activity/getActivityQuestionAnswerLog`,data)
  },
  // 获取拼团数据 
  getGroupBuyingOrderList(data) {
    return axios.post(`/activity-pc-manage-api/activity/getGroupBuyingOrderList`,data)
  },
  // 活动拼团商品列表
  getGroupBuyingGoodsList(data) {
    return axios.post(`/activity-pc-manage-api/activity/getGroupBuyingGoodsList`,data)
  },
  // 活动拼团团队列表
  getGroupBuyingTeamList(data) {
    return axios.post(`/activity-pc-manage-api/activity/getGroupBuyingTeamList`,data)
  },
  // 查询区域列表
  queryOrganizationList(data) {
    return axios.post(`/activity-pc-manage-api/activity/queryOrganizationList`,data)
  },
  // 保存参与与隐藏数据
  saveJoinAndHidden(data) {
    return axios.post(`/activity-pc-manage-api/activity/saveJoinAndHidden`,data)
  },
  // 求签数据
  getDrawList(data) {
    return axios.post(`/activity-pc-manage-api/activity/getDrawList`,data)
  },
  // 签文数据 
  getDrawLotsList(data) {
    return axios.post(`/activity-pc-manage-api/activity/getDrawLotsList`,data)
  },
  // 兑奖奖品 
  getPrizeList(data) {
    return axios.post(`/activity-pc-manage-api/activity/getPrizeList`,data)
  },
  // 已兑换奖品 
  getExchangedPrizeList(data) {
    return axios.post(`/activity-pc-manage-api/activity/getExchangedPrizeList`,data)
  },

  // 数钱数据相关接口
  getCountMoneyActivityAwards(data) {
    return axios.post(`/activity-pc-manage-api/activity/getCountMoneyActivityAwards`, data)
  }, 
  getActivityCountMoneyRecord(data) {
    return axios.post(`/activity-pc-manage-api/activity/getActivityCountMoneyRecord`,data)
  },
  getCountMoneyActivityWinAwards(data) {
    return axios.post(`/activity-pc-manage-api/activity/getCountMoneyActivityWinAwards`,data)
  },
  getWinPrizeAdressInfo(id) {
    return axios.get(`/activity-pc-manage-api/activity/getWinPrizeAdressInfo/${id}`)
  },
  // 活动详情-点击查看优惠券
  getCouponDetail({ filterData }) {
    return axios.get(`/activity-pc-manage-api/activity/getCouponTicketList/${filterData.sessionId}`)
  },
  // 活动详情-tab优惠券数据
  getcouponTabPages(data) {
    return axios.post(`/activity-pc-manage-api/activity/queryCouponOrderList`,data)
  }
}

// 数据报表
export const dataReport = {
  orgBoardInfo () {
    return axios.get('/activity-pc-manage-api/dataReport/orgBoardInfo')
  },
  orgDateReportPageList (data) {
    return axios.post('/activity-pc-manage-api/dataReport/orgDateReportPageList', data)
  },
  cusDateReportPageList (data) {
    return axios.post('/activity-pc-manage-api/dataReport/cusDateReportPageList', data)
  },
  storeDateReportPageList (data) {
    return axios.post('/activity-pc-manage-api/dataReport/storeDateReportPageList', data)
  },
  storeBoardInfo (id) {
    return axios.get(`/activity-pc-manage-api/dataReport/storeBoardInfo/${id}`)
  },
  staffDateReportPageList (data) {
    return axios.post('/activity-pc-manage-api/dataReport/staffDateReportPageList', data)
  },
  staffBoardInfo (code) {
    return axios.get(`/activity-pc-manage-api/dataReport/staffBoardInfo/${code}`)
  },
  activitySignUpPageList (data) {
    return axios.post('/activity-pc-manage-api/dataReport/activitySignUpPageList', data)
  },
  // 订单数据
  activityOrderList(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/activityOrderList`,data)
  },
  staffPullReportPageList (data) {
    return axios.post('/activity-pc-manage-api/dataReport/staffPullReportPageList', data)
  },
  queryActivityStaffAnalyzeData (data) {
    return axios.post('/activity-pc-manage-api/dataReport/queryActivityStaffAnalyzeData', data)
  },
  withdrawalPageList (data) {
    return axios.post('/activity-pc-manage-api/dataReport/withdrawalPageList', data)
  },
  customerWalletPageList (data) {
    return axios.post('/activity-pc-manage-api/dataReport/customerWalletPageList', data)
  },
  //微信对账-差异数据查询
  diffPageList (data) {
    return axios.post(`/activity-pc-manage-api/wxBill/diffPageList`,data)
  },
  //微信对账-重新对账
  againReconciliation (id) {
    return axios.get(`/activity-pc-manage-api/wxBill/againReconciliation/${id}`)
  },
  //微信对账-无需处理
  setDiff (id) {
    return axios.get(`/activity-pc-manage-api/wxBill/setDiff/${id}`)
  },
  //微信对账-一键对账
  reconciliation (data) {
    return axios.post(`/activity-pc-manage-api/wxBill/reconciliation`,data)
  },
  //对账记录查询
  reconciliationPageList (data) {
    return axios.post(`/activity-pc-manage-api/wxBill/reconciliationPageList`,data)
  },
  //活动核对-差异数据查询
  activityDiffPageList (data) {
    return axios.post(`/activity-pc-manage-api/wxBill/activityDiffPageList`,data)
  },
  //经销商核对-差异数据查询
  cusDiffPageList (data) {
    return axios.post(`/activity-pc-manage-api/wxBill/cusDiffPageList`,data)
  },
  //活动-经销商-重新对账
  cusAgainReconciliation (id) {
    return axios.get(`/activity-pc-manage-api/wxBill/cusAgainReconciliation/${id}`)
  },
  //活动对账-手动对账
  activityReconciliation (data) {
    return axios.post(`/activity-pc-manage-api/wxBill/activityReconciliation`,data)
  },
  //经销商对账-手动对账
  cusReconciliation (data) {
    return axios.post(`/activity-pc-manage-api/wxBill/cusReconciliation`,data)
  },
  //活动-经销商对账-异常数据更新为无需处理
  setCusDiff (id) {
    return axios.get(`/activity-pc-manage-api/wxBill/setCusDiff/${id}`)
  },
  //职员信息查询
  userManageGetUserInfo (userId) {
    return axios.get(`/activity-pc-manage-api/userManage/getUserInfo/${userId}`)
  },
  // 查询短息发送列表 
  querySmsSendList(data) {
    return axios.post(`/activity-pc-manage-api/sms/querySmsSendList`,data)
  },
  // 手机号接口数据分页
  queryCustomerPhoneAuthList(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/queryCustomerPhoneAuthList`,data)
  },
  // 查看手机号解密
  decodePhone(data) {
    return axios.post(`/activity-pc-manage-api/userManage/decodePhone`,data)
  },
  // 报名待核销 
  queryNotVerificationList(data) {
    return axios.post(`/activity-pc-manage-api/activity/queryNotVerificationList`,data)
  },
  // 核销记录列表 
  queryBatchVerificationLogList(data) {
    return axios.post(`/activity-pc-manage-api/activity/queryBatchVerificationLogList`,data)
  },
  // 核销选择订单 
  verificationChecked(data) {
    return axios.post(`/activity-pc-manage-api/activity/verificationChecked`,data) 
  },
  // 核销所有订单 
  verificationQueryResultOrder(data) {
    return axios.post(`/activity-pc-manage-api/activity/verificationQueryResultOrder`,data) 
  },
  // 查看核销明细  
  queryBatchVerificationDetailList(data) {
    return axios.post(`/activity-pc-manage-api/activity/queryBatchVerificationDetailList`,data) 
  },
  // 根据经销商编码查询名称
  getCusInfo(cusCode) {
    return axios.get(`/activity-pc-manage-api/wallet/getCusInfo/${cusCode}`)
  },
  // 转账 
  transfer(data) {
    return axios.post(`/activity-pc-manage-api/wallet/transfer`,data)
  },
  // 转账记录 
  queryTransferList(data) {
    return axios.post(`/activity-pc-manage-api/wallet/queryTransferList`,data)
  },
  // 充值记录 
  queryRechargeList(data) {
    return axios.post(`/activity-pc-manage-api/wallet/queryRechargeList`,data)
  },
  // 批量核销失败重试 
  batchVerificationRetry(batchVerificationId) {
    return axios.get(`/activity-pc-manage-api/activity/batchVerificationRetry/${batchVerificationId}`)
  },
  // 经销商钱包分页查询
  customerWalletPcPageList(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/customerWalletPcPageList`,data)
  },
  // 获取经销商钱包信息
  getCusWalletInfo(customerCode) {
    return axios.get(`/activity-pc-manage-api/wallet/getCusWalletInfo/${customerCode}`)
  },
  // 调账
  adjustBalance(data) {
    return axios.post(`/activity-pc-manage-api/wallet/adjustBalance`,data)
  },
  // 调账记录 
  queryWalletAdjustList(data) {
    return axios.post(`/activity-pc-manage-api/wallet/queryWalletAdjustList`,data)
  },
  // 获取红包数钱列表
  getCountMoney(data) {
    return axios.post(`/activity-pc-manage-api/activity/selectActivityCountMoneyWinPrizeList`, data)
  },
  // 退款列表 
  refundDataPageList(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/refundDataPageList`,data)
  },
  // 退款列表统计
  findRefundInfo() {
    return axios.get(`/activity-pc-manage-api/dataReport/findRefundInfo`)
  },
  // 退款日志 
  findRefundLog(id) {
    return axios.get(`/activity-pc-manage-api/dataReport/findRefundLog/${id}`)
  },
  // 同意报名订单退款
  agreeRefund(orderNo) {
    return axios.get(`/activity-pc-manage-api/audit/agreeRefund/${orderNo}`)
  },
  // 拒绝退款
  rejectRefund(data) {
    return axios.post(`/activity-pc-manage-api/audit/rejectRefund`,data)
  },
  // 入网列表
  unionMchPageList(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/unionMchPageList`,data)
  },
  // 修改银行卡
  modifyCustomerBankNo(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/modifyCustomerBankNo`,data)
  },

  // 区域列表
  getOrgIdList() {
    return axios.get(`/activity-pc-manage-api/dataReport/getOrgIdList`)
  },
   //入网列表-作废
   backUnionMchApply(customerId) {
    return axios.get(`/activity-pc-manage-api/dataReport/backUnionMchApply/${customerId}`)
  },
  // 保证金审核分页
  unionMchFrozenMarginAuditPageList(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/unionMchFrozenMarginAuditPageList`,data)
  },
  // 保证金审核
  unionMchFrozenMarginAudit(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/unionMchFrozenMarginAudit`,data)
  },
  // 查看银联冻结保证金
  customerUnionWalletDetail(customerId) {
    return axios.get(`/activity-pc-manage-api/dataReport/customerUnionWalletDetail/${customerId}`)
  },
  // 数据报表-财务数据核对-银联数据核对
  queryUnionOrderVerifySummary(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/queryUnionOrderVerifySummary`,data)
  },
  // 数据报表-财务数据核对-查看异常结果
  queryUnionOrderVerifyDetail(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/queryUnionOrderVerifyDetail`,data)
  },
  // 数据报表-财务数据核对-重新核对
  unionOrderReVerify(dateCode) {
    return axios.get(`/activity-pc-manage-api/dataReport/unionOrder/reVerify/${dateCode}`)
  },
  // 数据报表-财务数据核对-经销商支付管理
  queryCustomerPayWayList(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/queryCustomerPayWayList`,data)
  },
  // 数据报表-财务数据核对-经销商支付管理 
  modifyCustomerPayWay(data) {
    return axios.post(`/activity-pc-manage-api/dataReport/modifyCustomerPayWay`,data)
  },
  // 数据报表-财务数据核对-银联财务核对订单 
  checkCustomerUnionAmount(data) {
    return axios.post(`/activity-pc-manage-api/unionPay/checkCustomerUnionAmount`,data)
  },
  // 数据报表-财务数据核对-银联财务核对订单详情
  checkCustomerUnionOrderDtl(data) {
    return axios.post(`/activity-pc-manage-api/unionPay/checkCustomerUnionOrderDtl`,data)
  },
}

// 首页
export const home = {
  //区域查询
  getOrgList () {
    return axios.get('/activity-pc-manage-api/home/getOrgList')
  },
  // //统计数据查询
  // queryDataList (data) {
  //   return axios.post('/activity-pc-manage-api/home/queryDataList', data)
  // },
  //总计数据查询
  queryDataList (data) {
    return axios.get('/activity-pc-manage-api/home/queryTotalDataList', data)
  },
  // 报名成功率查询
  queryClosingRate (data) {
    return axios.post('/activity-pc-manage-api/home/queryClosingRate', {})
  },
  //时间范围查询统计数据查询
  rangeQueryDataList (data) {
    return axios.post('/activity-pc-manage-api/home/rangeQueryDataList', data)
  },
  //排行查询
  rankingDataList (data) {
    return axios.post('/activity-pc-manage-api/home/rankingDataList', data)
  },
  //活动数据查询
  activityDataList (data) {
    return axios.post('/activity-pc-manage-api/home/activityDataList', data)
  },
  //数据分析-H5登录数据查询
  h5LoginDataList (data) {
    return axios.post('/activity-pc-manage-api/home/h5LoginDataList', data)
  },
  //数据分析-销售额占比查询
  salesInfo (data) {
    return axios.post('/activity-pc-manage-api/home/salesInfo', data)
  },
  //数据分析-顾客数查询
  customersDataList (data) {
    return axios.post('/activity-pc-manage-api/home/customersDataList', data)
  },
  //微信数据-累计访问查询
  wxMiniVisitTotal (data) {
    return axios.post('/activity-pc-manage-api/wxMini/visitTotal', data)
  },
  //微信数据-省份查询
  wxMiniProvinceList (data) {
    return axios.get('/activity-pc-manage-api/wxMini/provinceList', data)
  },
  //微信数据-访问年龄查询
  wxMiniVisitAgeList (data) {
    return axios.post('/activity-pc-manage-api/wxMini/visitAgeList', data)
  },
  //微信数据-访问地域查询
  wxMiniVisitAreaList (data) {
    return axios.post('/activity-pc-manage-api/wxMini/visitAreaList', data)
  },
  //微信数据-访问性别查询
  wxMiniVisitGenderList (data) {
    return axios.post('/activity-pc-manage-api/wxMini/visitGenderList', data)
  },
  //微信数据-访问趋势查询
  wxMiniVisitTrend (data) {
    return axios.post('/activity-pc-manage-api/wxMini/visitTrend', data)
  },
}

// 问答
export const question = {
  // 新增 编辑试卷
  saveQuestion (data) {
    return axios.post('/activity-pc-manage-api/baseQuestion/saveQuestion', data)
  },
  selectQuestionPageList (data) {
    return axios.post('/activity-pc-manage-api/baseQuestion/selectQuestionPageList', data)
  },
  // 上下线
  updateQuestionGroupStatus (data) {
    return axios.get(`/activity-pc-manage-api/baseQuestion/updateQuestionGroupStatus/${data.id}/${data.state}`)
  },
  // 查看试题详情
  getQuestionGroupById (id) {
    return axios.get(`/activity-pc-manage-api/baseQuestion/getQuestionGroupById/${id}`)
  },
  // 新增修改数据字典 
  saveOrUpdateDict(data) {
    return axios.post('/activity-pc-manage-api/dict/saveOrUpdateDict',data)
  }
}

// 配置管理
export const configure = {
  wechatAddOrEdit(data) {
    return axios.post(`/activity-pc-manage-api/liveRoom/saveOrUpdate`,data)
  },
  queryLiveRooms(data) {
    return axios.post(`/activity-pc-manage-api/liveRoom/queryLiveRooms`,data)
  },
  updateUseStatus(data){
    return axios.get(`/activity-pc-manage-api/liveRoom/updateUseStatus/${data.liveRoomId}/${data.useStatus}`)
  },
  // 活动老师配置列表
  queryActivityConfigList(data) {
    return axios.post(`/activity-pc-manage-api/activityTeacherConfig/queryActivityConfigList`,data)
  },
  // 新增修改活动老师配置 
  saveOrUpdate(data) {
    return axios.post(`/activity-pc-manage-api/activityTeacherConfig/saveOrUpdate`,data)
  },
  // 特殊角色新增
  setStaffTkb(data) {
    return axios.post(`/activity-pc-manage-api/activityTeacherConfig/setStaffTkb`,data)
  },
  // 删除活动老师配置 
  delete(id) {
    return axios.get(`/activity-pc-manage-api/activityTeacherConfig/delete/${id}`)
  },
  // 删除直播间
  liveRoomDelete(liveRoomId) {
    return axios.get(`/activity-pc-manage-api/liveRoom/delete/${liveRoomId}`)
  },
  // 新增-修改 短信模板
  saveOrUpdateSmsTemplate(data) {
    return axios.post(`/activity-pc-manage-api/sms/saveOrUpdateSmsTemplate`,data)
  },
  // 查询短信模板列表
  querySmsTemplateList(data) {
    return axios.post(`/activity-pc-manage-api/sms/querySmsTemplateList`,data)
  },
  // 获取数据字典列表 
  queryDiceList(data) {
    return axios.post(`/activity-pc-manage-api/dict/queryDiceList`,data)  
  },
  // 新增/编辑/数据字典 
  saveOrUpdateDict(data) {
    return axios.post( `/activity-pc-manage-api/dict/saveOrUpdateDict`,data)
  },
  // 修改数据字典状态
  updateDictStatus(typeCode,status) {
    return axios.get(`/activity-pc-manage-api/dict/updateDictStatus/${typeCode}/${status}`)
  },
  // 获取字段详情
  getDictDataAll(typeCode) {
    return axios.get(`/activity-pc-manage-api/dict/getDictDataAll/${typeCode}`)
  },
  // 新增数据字典详情 
  saveOrUpdateDictData(data) {
    return axios.post(`/activity-pc-manage-api/dict/saveOrUpdateDictData`,data)
  },
  // 修改数据字典详情状态
  updateDictDataStatus(dictId,status) {
    return axios.get(`/activity-pc-manage-api/dict/updateDictDataStatus/${dictId}/${status}`)
  },
  // 查询token获取记录 
  queryRecordList(data) {
    return axios.post(`/activity-pc-manage-api/pc/queryRecordList`,data)
  },
  // 获取token 
  getToken(uid) {
    return axios.get(`/activity-pc-manage-api/pc/getToken/${uid}`)
  },
  // 解密历史记录分页查询
  decryptionRecordPageList(data) {
    return axios.post(`/activity-pc-manage-api/decryption/decryptionRecordPageList`,data)
  },
  // 查询线下入网商户列表
  queryOfflineUnionCustomerList(data) {
    return axios.post(`/activity-pc-manage-api/unionPay/queryOfflineUnionCustomerList`,data)
  },
  queryCustomers(data) {
    return axios.post(`/activity-pc-manage-api/unionPay/queryCustomers`,data)
  },
  // 新增或编辑银联线下商户信息
  addOrEditUnionOfflineCustomer(data) {
    return axios.post(`/activity-pc-manage-api/unionPay/addOrEditUnionOfflineCustomer`,data)
  },
  // 删除银联线下商户信息
  deleteUnionOfflineCustomer(id) {
    return axios.get(`/activity-pc-manage-api/unionPay/deleteUnionOfflineCustomer/${id}`)
  },
  // 办公平台角色权限配置列表
  roleConfigList(data) {
    return axios.post(`/activity-pc-manage-api/userManage/roleConfigList`,data)
  },
  // 办公平台角色权限配置详情
  orgTree() {
    return axios.get(`/activity-pc-manage-api/userManage/orgTree`)
  },
  // 保存角色区域权限配置
  saveRoleOrgAuth(data) {
    return axios.post(`/activity-pc-manage-api/userManage/saveRoleOrgAuth`,data)
  },
  // 查询销售目标配置列表
  querySaleTargetList(data) {
    return axios.post(`/activity-pc-manage-api/saleTarget/querySaleTargetList`,data)
  },
  // 保存销售目标配置
  saveSaleTarget(data) {
    return axios.post(`/activity-pc-manage-api/saleTarget/saveSaleTarget`,data)
  },
  // 查询区域列表
  queryAreaList(data) {
    return axios.post(`/activity-pc-manage-api/saleTarget/queryAreaList`,data)
  },
  // 删除销售目标配置
  deleteSaleTarget(id) {
    return axios.get(`/activity-pc-manage-api/saleTarget/delSaleTarget/${id}`)
  },
}

// 短信发送
export const message = {
  // 查询推送列表 
  queryBatchPushList(data) {
    return axios.post('/activity-pc-manage-api/smsBatchPush/queryBatchPushList', data)
  },
  // 根据经销商编码获取名称
  getCustomerName(customerId) {
    return axios.get(`/activity-pc-manage-api/smsBatchPush/getCustomerName/${customerId}`)
  },
  // 获取推送id
  getPushId() {
    return axios.get(`/activity-pc-manage-api/smsBatchPush/getPushId`)
  },
  // 保存推送手机号码 
  savePushPhone(data) {
    return axios.post(`/activity-pc-manage-api/smsBatchPush/savePushPhone`,data)
  },
  // 短信发送测试
  smsTestPush(data) {
    return axios.post(`/activity-pc-manage-api/smsBatchPush/smsTestPush`,data)
  },
  // 保存或修改短信推送 
  saveSmsBatchPush(data) {
    return axios.post(`/activity-pc-manage-api/smsBatchPush/saveSmsBatchPush`,data)
  },
  // 查询推送手机号列表
  queryPushPhoneList(data) {
    return axios.post(`/activity-pc-manage-api/smsBatchPush/queryPushPhoneList`,data)
  },
  // 查询导入手机号任务完成情况 
  importPhoneStatusPolling(id) {
    return axios.get(`/activity-pc-manage-api/smsBatchPush/importPhoneStatusPolling/${id}`)
  },
  // 删除推送手机号
  deletePushPhone(data) {
    return axios.get(`/activity-pc-manage-api/smsBatchPush/deletePushPhone/${data.pushPhoneId}/${data.phone}`)
  },
  // 修改推送手机号码
  updatePushPhone(data) {
    return axios.post(`/activity-pc-manage-api/smsBatchPush/updatePushPhone`,data)
  },
  // 详情查询 
  getPushDetail(pushId) {
    return axios.get(`/activity-pc-manage-api/smsBatchPush/getPushDetail/${pushId}`)
  },
  // 停止推送 
  stopPush(pushId) {
    return axios.get(`/activity-pc-manage-api/smsBatchPush/stopPush/${pushId}`)
  },
  // 核对手机号列表 
  checkPhoneList(pushId) {
    return axios.get(`/activity-pc-manage-api/smsBatchPush/checkPhoneList/${pushId}`)
  }

}

// 帮助与培训
export const help = {
  // 获取字典
  getDictData(typeCode) {
    return axios.get(`/activity-pc-manage-api/dict/getDictData/${typeCode}`)
  },
  // 新增编辑 
  saveOrUpdate(data) {
    return axios.post(`/activity-pc-manage-api/document/saveOrUpdate`, data)
  },
  // 查询文档列表
  queryDocumentList(data) {
    return axios.post(`/activity-pc-manage-api/document/queryDocumentList`,data)
  },
  // 上下线 
  onlineOrOfflineDocument(id,status) {
    return axios.get(`/activity-pc-manage-api/document/onlineOrOfflineDocument/${id}/${status}`)
  },
  // 删除 
  deleteDocument(id) {
    return axios.get(`/activity-pc-manage-api/document/deleteDocument/${id}`)
  }
}

// 消息通知 
export const messageInform = {
  queryMsgConfigList(data) {
    return axios.post(`/activity-pc-manage-api/msg/queryMsgConfigList`,data)
  },
  updateMsgConfig(data) {
    return axios.post(`/activity-pc-manage-api/msg/updateMsgConfig`,data)
  },
  pageInfo(data) {
    return axios.post(`/qu-platform-manage-api/role/pageInfo`,data)
  }
}

export const couponApi = {
  getCouponTicketList(sessionId) {
    return axios.post(`/qu-platform-manage-api/activity/getCouponTicketList/${sessionId}`)
  }
}
